import { logomarkDefinition } from '@deepdive-icons';
import styles from './Logomark.module.css';

/**
 * Figma: `Logomark` (43:2283) — "Brand icon asset. Fixed size: 26x26px.
 * Used in sidebar header. Vector-based, supports any fill color."
 *
 * Colour comes from `currentColor` so the fill is caller-controlled, per the
 * annotation. Defaults to icon/primary.
 */
export type LogomarkProps = {
  /** Accessible name. Defaults to "Reef"; pass an empty string if decorative. */
  label?: string;
  className?: string;
};

export function Logomark({ label = 'Reef', className }: LogomarkProps) {
  const decorative = label === '';

  return (
    <svg
      className={className ? `${styles.logomark} ${className}` : styles.logomark}
      viewBox={logomarkDefinition.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : label}
      aria-hidden={decorative || undefined}
      focusable="false"
    >
      {logomarkDefinition.paths.map((d) => (
        <path key={d.slice(0, 32)} d={d} fill="currentColor" />
      ))}
    </svg>
  );
}
